import { useOutletContext } from 'react-router-dom'

import { CostCentersAssignmentsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface CostCentersProps {
  applyingOn?: string
  resourceId: number
  resourceType: string
  skipQueries?: boolean
}

const useCostCentersAssignments = ({
  resourceId,
  resourceType,
  applyingOn,
  skipQueries = false,
}: CostCentersProps) => {
  const { hasNewStructureEnabled } = useOutletContext<{
    hasNewStructureEnabled: boolean
  }>()

  const { data, loading, refetch } = useQuery(CostCentersAssignmentsDocument, {
    variables: {
      applyingOn,
      resourceId,
      resourceType,
      sourceType: hasNewStructureEnabled ? 'structure_based' : 'legacy',
    },
    skip: skipQueries,
  })

  const assignments = data?.costCenters.assignmentsConnection.nodes || []

  return {
    isLoading: loading,
    assignments,
    refetch,
  }
}

export default useCostCentersAssignments
